// §09 presentation behavior over the real, server-owned Monica messages.
// Only disclosure state is local; no message or action is submitted here.
export function attachAiosMessageLayout(root) {
  const expanded = new Map()
  const observed = new Set()
  const pending = new Set()
  let frame = null
  const queueMeasure = inner => {
    pending.add(inner)
    if (frame !== null) return
    frame = requestAnimationFrame(() => {
      frame = null
      // Read every affected message before writing its disclosure attribute.
      // One drawer observer and one frame also coalesce LiveView patches.
      const measured = [...pending].filter(inner => root.contains(inner)).map(inner => ({
        bubble: inner.closest('.msg__bubble'),
        long: inner.scrollHeight > (Number.parseFloat(getComputedStyle(inner).lineHeight) || 20.8) * 10 + 1
      }))
      pending.clear()
      measured.forEach(({bubble,long}) => bubble?.toggleAttribute('data-long',long))
    })
  }
  const resize = new ResizeObserver(entries => entries.forEach(entry => queueMeasure(entry.target)))
  const sync = () => {
    for (const inner of root.querySelectorAll('[data-aios-message-text]')) {
      if (!observed.has(inner)) { observed.add(inner); resize.observe(inner) }
      queueMeasure(inner)
    }
    for (const inner of observed) if (!root.contains(inner)) { resize.unobserve(inner); observed.delete(inner) }
    for (const button of root.querySelectorAll('.msg__more,[data-aios-accordion]')) {
      const owner = button.closest('[id]')
      const open = expanded.get(owner?.id) === true
      button.setAttribute('aria-expanded', String(open))
      const panel = button.matches('.msg__more') ? owner.querySelector('.msg__clip') : document.getElementById(button.getAttribute('aria-controls'))
      if (panel) panel.dataset.open = String(open)
      if (button.matches('.msg__more')) button.querySelector('span').textContent = open ? button.dataset.lessLabel : button.dataset.moreLabel
    }
  }
  const click = event => {
    const button = event.target.closest('.msg__more,[data-aios-accordion]')
    if (!button || !root.contains(button)) return
    const owner = button.closest('[id]')
    expanded.set(owner.id, button.getAttribute('aria-expanded') !== 'true')
    sync()
  }
  root.addEventListener('click',click)
  sync()
  document.fonts?.ready.then(() => { if (root.isConnected) sync() })
  return {sync, destroy() { root.removeEventListener('click',click); resize.disconnect(); observed.clear(); pending.clear(); if(frame !== null) cancelAnimationFrame(frame) }}
}
